import React, { useState } from 'react'

import {
  FormControlLabel,
  FormHelperText,
  Grid,
  Switch,
  TextField,
  Typography,
} from '@material-ui/core'
import { Controller, useFormContext } from 'react-hook-form'

import { LoadingFeedback } from 'components'
import { JourneyRecaptcha } from '../../components'

import useSupplierJourney from 'hooks/useSupplierJourney'
import useSnackbar from 'hooks/useSnackbar'

import helpers from 'helpers'
import * as service from 'service'
import useAuthSupplier from 'hooks/useAuthSupplier'

const DocumentStep = () => {
  const [isLoading, setIsLoading] = useState(false)

  const snackbar = useSnackbar()
  const { handleSubmit, control, errors } = useFormContext()
  const {
    disableRecaptcha,
    handleAcceptedRecaptcha,
    handleNext,
    recaptcha,
    recaptchaRef,
    resetRecaptcha,
    portalToken,
    setCompanySupplierToken,
    setCompanySupplierId,
    setSupplier,
    international,
    setInternational,
    company,
  } = useSupplierJourney()
  const { isLoading: isAuthSupplierLoading } = useAuthSupplier()

  const handleDocumentFormat = (event) => {
    if (international) return

    event.target.value = helpers.formatters.document.identify(
      event.target.value,
      true,
    )
  }

  const onSubmit = async (data) => {
    try {
      setIsLoading(true)

      const response =
        await service.supplierPortal.companySuppliers.validateByDocument({
          token: portalToken,
          document: data.document,
          recaptcha: recaptcha,
        })

      const companySupplier = response?.data?.companySupplier

      setCompanySupplierToken(companySupplier?.token)
      setSupplier(companySupplier?.supplier ?? null)
      setCompanySupplierId(companySupplier?.id ?? null)

      handleNext()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error.response.data.error) ||
          'Erro ao validar documento',
        variant: 'error',
      })
    } finally {
      resetRecaptcha()
      setIsLoading(false)
    }
  }

  return (
    <>
      <LoadingFeedback open={isLoading || isAuthSupplierLoading} />
      <Grid container spacing={6} justifyContent="center">
        <Grid item xs={12} md={8}>
          <Typography
            variant="h2"
            color="primary"
            style={{ textAlign: 'center' }}
          >
            Avaliação de Fornecedores da Organização {company?.name}
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography
            variant="h4"
            style={{ fontWeight: 400, textAlign: 'center' }}
            color="primary"
          >
            Por favor, informe seu documento para avançar.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <form id="form-register" onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={4} justifyContent="center">
              <Grid item xs={12} md={8}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={international}
                      onChange={(event) =>
                        setInternational(event.target.checked)
                      }
                      color="primary"
                    />
                  }
                  label="Documento internacional"
                />
                <FormHelperText>
                  Ative se a sua empresa não tem CPF ou CNPJ. Digite o documento
                  como foi informado à empresa que enviou o convite.
                </FormHelperText>
              </Grid>
              <Grid item xs={12} md={8}>
                <Controller
                  as={
                    <TextField
                      fullWidth
                      label="Documento"
                      error={!!errors.document}
                      helperText={errors?.document?.message}
                    />
                  }
                  name="document"
                  control={control}
                  mode="onChange"
                  onChange={([event]) => {
                    handleDocumentFormat(event)
                    return event.target.value
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={8}
                style={{ display: 'flex', justifyContent: 'center' }}
              >
                <JourneyRecaptcha
                  recaptchaRef={recaptchaRef}
                  onChange={handleAcceptedRecaptcha}
                  onExpired={disableRecaptcha}
                  onErrored={disableRecaptcha}
                />
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </>
  )
}

export default DocumentStep
